import type { MouseEvent } from 'react'

export function followLink(event: MouseEvent<HTMLAnchorElement>, to: string, navigate: (to: string) => void): void {
	if (event.defaultPrevented) return
	if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
	event.preventDefault()
	navigate(to)
}
